import "./textarea.scss";

interface TextareaProps {
  name: string;
  label: string;
  placeholder: string;
  value: any;
  setValue?: any;
  required?: boolean;
  asterisk?: boolean;
  rows: number;
}

function Textarea({ name, label, placeholder, value, setValue, required, asterisk = true, rows }: TextareaProps) {
  function handleChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
    setValue(event);
  }

  return (
    <div className={`form-input`}>
      <label className="font-source-sans-pro">
        {label}
        {required && asterisk ? <span className="text-red"> *</span> : ""}
      </label>
      <textarea
        rows={rows}
        className={`font-source-sans-pro textarea`}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        required
      />
    </div>
  );
}

export default Textarea;
